require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _color = _interopRequireDefault(require("color"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _theming = require("../../core/theming");

var _colors = require("../../styles/colors");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Avatar/AvatarIcon.tsx";
var defaultSize = 64;

var Avatar = function (_React$Component) {
  (0, _inherits2["default"])(Avatar, _React$Component);

  function Avatar() {
    (0, _classCallCheck2["default"])(this, Avatar);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Avatar).apply(this, arguments));
  }

  (0, _createClass2["default"])(Avatar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? defaultSize : _this$props$size,
          style = _this$props.style,
          theme = _this$props.theme,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["icon", "size", "style", "theme"]);

      var _ref = _reactNative.StyleSheet.flatten(style) || {},
          _ref$backgroundColor = _ref.backgroundColor,
          backgroundColor = _ref$backgroundColor === void 0 ? theme.colors.primary : _ref$backgroundColor,
          restStyle = (0, _objectWithoutProperties2["default"])(_ref, ["backgroundColor"]);

      var textColor = this.props.color || ((0, _color["default"])(backgroundColor).isLight() ? 'rgba(0, 0, 0, .54)' : _colors.white);
      return React.createElement(_reactNative.View, (0, _extends2["default"])({
        style: [{
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: backgroundColor
        }, styles.container, restStyle]
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        }
      }), React.createElement(_Icon["default"], {
        source: icon,
        color: textColor,
        size: size * 0.6,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81
        }
      }));
    }
  }]);
  return Avatar;
}(React.Component);

(0, _defineProperty2["default"])(Avatar, "displayName", 'Avatar.Icon');
(0, _defineProperty2["default"])(Avatar, "defaultProps", {
  size: defaultSize
});

var styles = _reactNative.StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center'
  }
});

var _default = (0, _theming.withTheme)(Avatar);

exports["default"] = _default;